import { render, staticRenderFns } from "./SettingsNote.vue?vue&type=template&id=dea38afa&"
import script from "./SettingsNote.vue?vue&type=script&lang=js&"
export * from "./SettingsNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports